import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  ${media.smallOnly`
    justify-content: center;
  `}
`;
export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding-top: 10px;
  padding-bottom: 10px;
`;
export const ToggleContainer = styled.div.attrs({
  'data-test': 'ToggleContainer',
})`
  display: flex;
  align-items: center;
  justify-content: center;
`;
